import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";

import { useState } from "react";
import classnames from "classnames";
import SettingsManage from "./Procedure/settingsManage";
import TopicsManage from "./Step/topicsManage";
import CoursesManage from "./Stage/coursesManage";
import ImportJsonButton from "./importJsonButton";
import ExportJsonButton from "./exportJsonButton";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function HomeMonoPageLearn() {
    const { chapterName: urlChapterName, folderName } = useParams();
    const folderNameSansExt = folderName?.replace(/\.json$/i, "") || "";
    const courseNameSansVariante =
        folderNameSansExt.replace(/_[A-Za-z]{2,5}(?:-[A-Za-z]{2,5})?$/, "") || folderNameSansExt;
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        const chapter = urlChapterName || folderNameSansExt.split("_")[0];
        if (location.search.includes("from=variant")) {
            navigate(`/languageManageWork/${chapter}?from=variant`);
        } else {
            navigate(`/languageManageLearn/${chapter}`);
        }
    };

    // Données Redux (conservées)
    const courses = useSelector(
        (state) => state.jsonLearn?.jsonData?.process?.courses || []
    );
    const firstCourseID =
        (courses && courses.length > 0) ? courses[0].courseID : null;

    // Onglet actif
    const [activeTab, setActiveTab] = useState("1");

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <div className="page-content">
            <h1 className="text-primary text-center">iXiMAKER - LEARN</h1>
            <h2 className="text-tertiary mb-2 text-center">
                Gestion des évaluations
            </h2>
            <h3 className="text-primary text-center">
                {courseNameSansVariante}
            </h3>

            {/* <div className="col-md-12 d-flex justify-content-center">
                <p className="col-md-6 border border-primary rounded text-center small p-2">
                    Pour traduire une évaluation, <b>exportez-la</b>
                    <br />
                    et faites-la <b>traduire</b> par votre IA préférée,
                    puis <b>importez-la</b>.
                </p>
            </div> */}

            <Container fluid>
                <Row>
                    <Col lg={12}>
                        {/* Boutons */}
                        <div className="col-md-12 mb-3">
                            <div className="d-flex justify-content-center align-items-center gap-4">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={handleGoBack}
                                >
                                    <i className="dripicons-arrow-left align-middle"></i>{" "}
                                    Retour aux variantes
                                </button>

                                <ExportJsonButton type="learn" />
                                <ImportJsonButton type="learn" />
                            </div>
                        </div>

                        <Card>
                            <CardBody>
                                <p className="card-title-desc">
                                    Sélectionnez une section pour afficher son
                                    contenu ⤵️
                                </p>

                                {/* ===== TABS HORIZONTAUX ===== */}
                                <Nav
                                    tabs
                                    className="justify-content mb-4"
                                >
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => toggleTab("1")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            1️⃣ Paramètres
                                        </NavLink>
                                    </NavItem>
 
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "2",
                                            })}
                                            onClick={() => toggleTab("2")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            2️⃣ Questionnaires
                                        </NavLink>
                                    </NavItem>
 
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "3",
                                            })}
                                            onClick={() => toggleTab("3")}
                                            style={{ cursor: "pointer" }}
                                        >
                                            3️⃣ Evaluation
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                {/* ===== CONTENU ===== */}
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <SettingsManage />
                                    </TabPane>

                                    <TabPane tabId="2">
                                        <TopicsManage />
                                    </TabPane>

                                    <TabPane tabId="3">
                                        <CoursesManage />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default HomeMonoPageLearn;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license